import * as React from 'react';
export const IcForward = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.41 9.59l-5-5a2 2 0 00-2.18-.44A2 2 0 0013 6v2S2.75 9.86 2 19.84A1.09 1.09 0 003.07 21a1.08 1.08 0 001-.78C4.68 18.39 6.67 14 13 14v2a2 2 0 001.23 1.85 2 2 0 002.18-.44l5-5a2 2 0 000-2.82z'
      fill='currentColor'
    />
  </svg>
);
